

















import Vue from "vue";
import iwInputText from "@/encoding/components/buildingBlocks/InputText.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputText: iwInputText,
    },
    props: {
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
    },
    data: function() {
        return {
            pathInStore: "customer.vatNumber", // TO CHANGE WITH CORRECT PATH
            specificId: uuidv4() as string,
            vatInvalidError: null as string|null
        };
    },
    computed: {
        /**
         * `vatInvalidError` is checked from this component and `errorMessage`
         * comes from a parent component, which gets its data from the API.
         */
        errorsMessage: function(): string {
            return this.vatInvalidError ?? this.errorMessage ?? "";
        },

        vatNumber: function(): string|null {
            return this.$store.getters["FormModule/getValueUI"](this.pathInStore);
        },
    },
    methods: {
        updateText: function ({ target }: InputEvent) {
            const value = (target as HTMLInputElement).value;
            this.$store.commit("FormModule/addValueUI", { path: this.pathInStore, value: value });
        },

        handleBlur: function ({ target }: InputEvent) {
            const value = (target as HTMLInputElement).value;

            if (!value) { return; }

            const vatValid = this.checkVatValidity(value);

            this.vatInvalidError = !vatValid
                ? this.$t("vat_number_invalid") as string
                : null;
            this.$store.commit("FormModule/addValueUI", {path: "vatNumberError", value: !vatValid});
        },

        /**
         * API only wants BE0123456789.
         *
         * This function turns the following examples into the right format:
         * - 123456789
         * - 0123456789
         * - BE0123456789
         * - BE0123.456.789
         * - 123.456.789
         *
         * We also check the provided number valid in Belgium. The rule is:
         * {last two digits} must be: 97 minus {first eight digits} modulo 97.
         */
        checkVatValidity: function(vatNumber: string): boolean {

            // Only keep numbers. Reject if not 9 or 10 numbers.

            vatNumber = vatNumber.replace(/\D/gi, "");
            if (![9, 10].includes(vatNumber.length)) { return false; }

            // Make sure it starts with 'BE' or 'BE0' and update the field.

            const padString = vatNumber.length == 9 ? "BE0" : "BE";
            vatNumber = vatNumber.padStart(12, padString);

            this.$store.commit("FormModule/addValueUI", { path: this.pathInStore, value: vatNumber });

            // Belgian VAT check.

            const firstEightDigits = Number(vatNumber.slice(2, 10));
            const lastTwoDigits = Number(vatNumber.slice(-2));

            return lastTwoDigits == 97 - firstEightDigits % 97;
        }
    }
});
